import { render, staticRenderFns } from "./ModalHeaderControls.vue?vue&type=template&id=da72d928&scoped=true"
import script from "./ModalHeaderControls.vue?vue&type=script&lang=js"
export * from "./ModalHeaderControls.vue?vue&type=script&lang=js"
import style0 from "./ModalHeaderControls.vue?vue&type=style&index=0&id=da72d928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da72d928",
  null
  
)

export default component.exports